const c = {
    media_chan: {
        direct_mail: 1,
        print: 2,
        email: 3,
        online_display: 5,
        social_media: 6,
        search_engine_marketing: 9,
        online_video: 10,
        dashboard_only: 13,
        website_url: 14,
    },
    communication_type: {
        business_content_incentive: 1,

    },
    sector: {
        banking: 87,
        credit_card: 90,
        mortgage_loan: 6,
        retail: 266,
        telecomm: 9,
        travel_leisure: 219,
        energy: 315,
        automotive: 372,
        insurance: 4,
        investment_annulities: 5,
        pharmaceutical: 315,
        real_estate: 522,
        retail_consumer: 266,
        shipping: 525,
        hr_payroll: 530,
        non_profit: 560,
        consumer_service:559,
    },
    category: {
        credit_access_offer: 179,
        payment_card: 178,
        annuities: 97,
        health_insurance: 14,
        hospital_medical_group: 454,
    },
    subcategory: {
        dental: 506,
    },
    audience: {
        consumer: 1,
        employee_business_owner: 2,
    },
    product_validation: [
        'media_chan',
        'audience',
        'entrydate',
        // 'current_pdf'     
        // 'product_name',
        // 'product_headline',
        // 'companies',
        // 'sectors',
        // 'mailing_type',
        // 'state_province'

    ],
    product_validation_approval: [
        'product_img',
        'product_name',
        'product_headline',
        'companies',
        'sectors',
        'mailing_type',
        'state_province',
        'offer_origin',
        'personalization'
    ],
    product_fields: {
        'product_img': 'Product Image',
        'entrydate': 'Entry Date',
        // 'current_pdf':'Product PDF',
        "offer_origin": 'Offer Origin',
        'media_chan': 'Media Channel',
        'audience': 'Audience',
        'product_name': 'Product Name',
        'product_headline': 'Product Headline',
        'companies': 'Companies',
        'sectors': 'Sector',
        'mailing_type': 'Mailing Type',
        'state_province': 'State/Province',
    },
    email_validation: ['electronic_type'],
    email_fields: { 'electronic_type': 'Electronic Type' },
    print_media_validation: [
        "dm_tm_source",
        // 'media_chan',
        // 'audience',
        // 'product_name',
        // 'product_headline',
        // 'companies',
        // 'sectors',
        // 'mailing_type'
    ],
    print_media_validation_approval: ['publication'],
    print_media_fields: {
        'publication': 'Publication',
        'dm_tm_source': 'DM/TM Source ',
        'media_chan': 'Media Channel',
        'audience': 'Audience',
        'product_name': 'Product Name',
        'product_headline': 'Product Headline',
        'companies': 'Companies',
        'sectors': 'Sector/Category',
        'mailing_type': 'Mailing Type'

    },
    online_display_validation_approval: ['mobile_digital_file_url'],
    online_display_fields: { 'mobile_digital_file_url': 'Product Media' },
    direct_mail_validation: [
        "dm_tm_source",
        // 'ec_content_type'
        // 'media_chan',
        // 'audience',
        // 'product_name',
        // 'product_headline',
        // 'companies',
        // 'sectors',
        // 'mailing_type',
        // "state_province"
    ],
    delivery_validation_approval: ["delivery_method"],
    //    "package_type", "pre_sorted"],
    direct_mail_fields: {
        'dm_tm_source': 'DM/TM Source',
        'media_chan': 'Media Channel',
        'audience': 'Audience',
        'product_name': 'Product Name',
        'product_headline': 'Product Headline',
        "product_img": 'Product Image',
        'companies': 'Companies',
        'sectors': 'Sector/Category',
        'mailing_type': 'Mailing Type',
        'state_province': 'State Province'

    },
    social_media_validations: [ //"media_channel",
        'external_link', 'social_media_add_type'],
    social_media_fields: {
        'external_link': 'External Link',
        'social_media_add_type': 'Social Media ad Type',
        // 'media_chan': 'Media Channel',
        // 'audience': 'Audience',
        // 'product_name': 'Product Name',
        // 'product_headline': 'Product Headline',
        // 'companies': 'Companies',
        // 'sectors': 'Sector/Category',
        // 'mailing_type': 'Mailing Type',
        // 'state_province':'State Province'
    },
    delivery_fields: {
        "delivery_method": 'Delivery Method '
        //, "pre_sorted": 'Pre-Sorted', "package_type": 'Package-Type'
    },
    image_base_url: '',
    creditAccessCheckActions: {
        PromotionalOfferUsageFee: 'ProductData/setCreditCardBalanceTransferIntroductoryUsageFee',
        tier_2_balance_transfer_introductory_usage_fee: 'ProductData/setCreditCardTier2BalanceTransferIntroductoryUsageFee',
        PromotionalOfferMaximumFee: 'ProductData/setCreditCardBalanceTransferIntroductoryMaximumFee',
        PromotionalOfferMinimumFee: 'ProductData/setCreditCardBalanceTransferIntroductoryMinimumFee',
        tier_2_balance_transfer_introductory_minimum_fee: 'ProductData/setCreditCardTier2BalanceTransferIntroductoryMinimumFee',
        balance_transfer_introductory_fee_period: 'ProductData/setCreditCardBalanceTransferIntroductoryFeePeriod',
        balance_transfer_introductory_usage_fee: 'ProductData/setCreditCardBalanceTransferIntroductoryUsageFee',
        balance_transfer_maximum_fee: 'ProductData/setCreditCardBalanceTransferMaximumFee',
        balance_transfer_minimum_fee: 'ProductData/setCreditCardBalanceTransferMinimumFee',
        tier_2_balance_transfer_minimum_fee: 'ProductData/setCreditCardTier2BalanceTransferMinimumFee',
        balance_transfer_regular_apr: 'ProductData/setCreditCardBalanceTransferRegularApr',
        balance_transfer_regular_rate_type: 'ProductData/setCreditCardBalanceTransferRegularRateType',
        balance_transfer_usage_fee: 'ProductData/setCreditCardBalanceTransferUsageFee',
        cash_advance_introductory_fee_period: 'ProductData/setCreditCardCashAdvanceIntroductoryFeePeriod',
        cash_advance_introductory_maximum_fee: 'ProductData/setCreditCardCashAdvanceIntroductoryMaximumFee',
        cash_advance_introductory_minimum_fee: 'ProductData/setCreditCardCashAdvanceIntroductoryMinimumFee',
        cash_advance_introductory_usage_fee: 'ProductData/setCreditCardCashAdvanceTier2IntroductoryUsageFee',
        cash_advance_maximum_fee: 'ProductData/setCreditCardCashAdvanceMaximumFee',
        cash_advance_minimum_fee: 'ProductData/setCreditCardCashAdvanceMinimumFee',
        cash_advance_regular_apr: 'ProductData/setCreditCardCashAdvanceRegularApr',
        cash_advance_regular_rate_type: 'ProductData/setCreditCardCashAdvanceRegularRateType',
        cash_advance_usage_fee: 'ProductData/setCreditCardCashAdvanceUsageFee',
        perchase_regular_apr: 'ProductData/setCreditCardPerchaseRegularApr',
        perchase_regular_rate_type: 'ProductData/setCreditCardPerchaseRegularRateType',
        promotional_offer: 'ProductData/setCreditCardPromotionalOffer',
        purchase_introductory_fee_period: 'ProductData/setCreditCardPurchaseIntroductoryFeePeriod',
        purchase_introductory_maximum_fee: 'ProductData/setCreditCardPurchaseIntroductoryMaximumFee',
        purchase_introductory_minimum_fee: 'ProductData/setCreditCardPurchaseIntroductoryMinimumFee',
        purchase_introductory_usage_fee: 'ProductData/setCreditCardPurchaseIntroductoryUsageFee',
        tier_1_balance_transfer_introduction_apr: 'ProductData/setCreditCardTier1BalanceTransferIntroductionApr',
        tier_1_balance_transfer_introductory_period: 'ProductData/setCreditCardTier1BalanceTransferIntroductoryPeriod',
        tier_1_cash_advance_introductory_apr: 'ProductData/setCreditCardCashAdvanceIntroductoryApr',
        tier_1_cash_advance_introductory_period: 'ProductData/setCreditCardCashAdvanceIntroductoryAprPeriod',
        tier_1_purchase_introductory_apr: 'ProductData/setCreditCardTier1PurchaseIntroductoryApr',
        tier_1_purchase_introductory_period: 'ProductData/setCreditCardTier1PurchaseIntroductoryPeriod',
        tier_2_balance_transfer_introduction_apr: 'ProductData/setCreditCardTier2BalanceTransferIntroductionApr',
        tier_2_balance_transfer_introductory_period: 'ProductData/setCreditCardTier2BalanceTransferIntroductoryPeriod',
        tier_2_cash_advance_introductory_apr: 'ProductData/setCreditCardTier2CashAdvanceIntroductoryApr',
        tier_2_cash_advance_introductory_period: 'ProductData/setCreditCardCashAdvanceTier2IntroductoryAprPeriod',
        tier_2_purchase_introductory_apr: 'ProductData/setCreditCardTier2PurchaseIntroductoryApr',
        tier_2_purchase_introductory_period: 'ProductData/setCreditCardTier2PurchaseIntroductoryPeriod',
    },
    productActions: {
        entryID: 'ProductData/setEntryDate',
        fauxCheck: 'ProductData/setFauxCheck',
        tipOnCard: 'ProductData/setTipOnCard',
        handwriting: 'ProductData/setHandwriting',
        feeProduct: 'ProductData/setFeeProduct',
        gender: 'ProductData/setGender',
        isCiti: 'ProductData/setCiti',
        isMobile: 'ProductData/setIsMobile',
        isPrescreen: 'ProductData/setIsPrescreen',
        isStateSpecific: 'ProductData/setStateSpecific',
        offerExpiryDate: 'ProductData/setOfferExpiry',
        personalization: 'ProductData/setPersonalization',
        productHeadline: 'ProductData/setProductHeadline',
        productName: 'ProductData/setProductName',
        worksiteVoluntary: 'ProductData/setWorksiteVoluntary',
        dm_tm_source: 'ProductData/setProductDmTmSource',
        primaryCountry: 'ProductData/setPrimaryCountry',
        prescription: 'ProductData/setPerscription',
        is_hphsa: 'ProductData/setIsHphsa',
        product_status: 'ProductData/setProductStatus',
        product_comment: 'ProductData/setProductComment',
        entry_id: 'ProductData/setEntryId',
        mobile_digital_file_type: 'ProductData/setMobileDigtialFileType',
        mobile_digital_file_url: 'ProductData/setMobileDigtialFileURL',
        mobile_digital_file_size: 'ProductData/setMobileDigtialFileSize',
        media_channel_name: 'ProductData/setMediaChannelName',
        is_deleted: 'ProductData/setIsDeleted',
        added_to_database: "ProductData/setAddedToDatabase"
    },
    productActionsMappingData: {
        entryID: 'ProductData/setEntryDate',
        fauxCheck: 'ProductData/setFauxCheck',
        tipOnCard: 'ProductData/setTipOnCard',
        handwriting: 'ProductData/setHandwriting',
        feeProduct: 'ProductData/setFeeProduct',
        gender: 'ProductData/setGender',
        isCiti: 'ProductData/setCiti',
        isMobile: 'ProductData/setIsMobile',
        isPrescreen: 'ProductData/setIsPrescreen',
        isStateSpecific: 'ProductData/setStateSpecific',
        offerExpiryDate: 'ProductData/setOfferExpiry',
        personalization: 'ProductData/setPersonalization',
        productHeadline: 'ProductData/setProductHeadline',
        productName: 'ProductData/setProductName',
        worksiteVoluntary: 'ProductData/setWorksiteVoluntary',
        dm_tm_source: 'ProductData/setProductDmTmSource',
        primaryCountry: 'ProductData/setPrimaryCountry',
        prescription: 'ProductData/setPerscription',
        is_hphsa: 'ProductData/setIsHphsa',
        product_status:'ProductData/setProductStatus',
        product_comment:'ProductData/setProductComment',
        entry_id:'ProductData/setEntryId',
        mobile_digital_file_type:'ProductData/setMobileDigtialFileType',
        mobile_digital_file_url:'ProductData/setMobileDigtialFileURL',
        mobile_digital_file_size:'ProductData/setMobileDigtialFileSize',
        media_channel_name:'ProductData/setMediaChannelName',
        mchanne_id:'ProductData/setMediaChannel',
        offer_origin_id:'ProductData/setOfferOrigin',
        mpanel_id:'ProductData/setAudience',
        business_content:'ProductData/setBusinessContent',
        mtype_id:'ProductData/setMailingType',
        delivery_method_id:'ProductData/set_delivery_method',
        delivery_type_id:'ProductData/set_delivery_type',
        postage_id:'ProductData/set_delivery_postage',
        presorted_id:'ProductData/set_delivery_pre_sorted',
        package_type_id:'ProductData/set_delivery_package_type',
        socialmedia_adtype:'ProductData/setMediaChannelSocialMediaAddType',
        is_deleted:'ProductData/setIsDeleted',
        added_to_database: "ProductData/setAddedToDatabase"
    },
    energyActions: {
        ECancelFee: 'ProductData/setEnergyCancelFee',
        ECancelFeeDetail: 'ProductData/setEnergyCancelFeeDetails',
        EOfferPrice: 'ProductData/setEnergyOfferPricePerKwh',
        EOfferPrice2: 'ProductData/setEnergyOfferPricePerKwh2',
        EOfferPrice3: 'ProductData/setEnergyOfferPricePerKwh3',
        EOfferPrice4: 'ProductData/setEnergyOfferPricePerKwh4',
        ERateType: 'ProductData/setEnergyRateType',
        ERateType2: 'ProductData/setEnergyRateType2',
        ERateType3: 'ProductData/setEnergyRateType3',
        ERateType4: 'ProductData/setEnergyRateType4',
        ETermLength: 'ProductData/setEnergyTermLength',
        ETermLength2: 'ProductData/setEnergyTermLength2',
        ETermLength3: 'ProductData/setEnergyTermLength3',
        ETermLength4: 'ProductData/setEnergyTermLength4',
    },
    productIncentiveActions: {
        sign_on_accelerator_per_1: 'ProductData/setSignOn1AcceleretorPer',
        sign_on_accelerator_per_2: 'ProductData/setSignOn2AcceleretorPer',
        sign_on_accelerator_per_3: 'ProductData/setSignOn3AcceleretorPer',
        sign_on_accelerator_type_1: 'ProductData/setSignOn1AcceleretorType',
        sign_on_accelerator_type_2: 'ProductData/setSignOn2AcceleretorType',
        sign_on_accelerator_type_3: 'ProductData/setSignOn3AcceleretorType',
        sign_on_category_limited_1: 'ProductData/setSignOn1LimitSpecificCategory',
        sign_on_category_limited_2: 'ProductData/setSignOn2LimitSpecificCategory',
        sign_on_category_limited_3: 'ProductData/setSignOn3LimitSpecificCategory',
        sign_on_fixed_date_1: 'ProductData/setSignOn1FixedDate',
        sign_on_fixed_date_2: 'ProductData/setSignOn2FixedDate',
        sign_on_fixed_date_3: 'ProductData/setSignOn3FixedDate',
        ongoing_incentive: 'ProductData/setOngoingIncentive',
        sign_on_incentive_1: 'ProductData/setSignOn1Incentive',
        sign_on_incentive_2: 'ProductData/setSignOn2Incentive',
        sign_on_incentive_3: 'ProductData/setSignOn3Incentive',
        sign_on_incentive_type_1: 'ProductData/setSignOn1IncentiveType',
        sign_on_incentive_type_2: 'ProductData/setSignOn2IncentiveType',
        sign_on_incentive_type_3: 'ProductData/setSignOn3IncentiveType',
        sign_on_incentive_value_1: 'ProductData/setSignOn1IncentiveValue',
        sign_on_incentive_value_2: 'ProductData/setSignOn2IncentiveValue',
        sign_on_incentive_value_3: 'ProductData/setSignOn3IncentiveValue',
        sign_on_incentive_window_1: 'ProductData/setSignOn1IncentiveWindowMonth',
        sign_on_incentive_window_2: 'ProductData/setSignOn2IncentiveWindowMonth',
        sign_on_incentive_window_3: 'ProductData/setSignOn3IncentiveWindowMonth',
        sign_on_max_award_1: 'ProductData/setSignOn1MaxAward',
        sign_on_max_award_2: 'ProductData/setSignOn2MaxAward',
        sign_on_max_award_3: 'ProductData/setSignOn3MaxAward',
        sign_on_max_spend_1: 'ProductData/setSignOn1IncentiveMaxSpend',
        sign_on_max_spend_2: 'ProductData/setSignOn2IncentiveMaxSpend',
        sign_on_max_spend_3: 'ProductData/setSignOn3IncentiveMaxSpend',
        sign_on_min_spend_1: 'ProductData/setSignOn1IncentiveMinSpend',
        sign_on_min_spend_2: 'ProductData/setSignOn2IncentiveMinSpend',
        sign_on_min_spend_3: 'ProductData/setSignOn3IncentiveMinSpend',
    },
    nonHeaderRoute: [
        'product',
        'emailbodypopup',
        'ManagePdf'
    ],
    base_document_path: {
        "name": "CSV2_PRODUCT/current/"
    },pdf_content_settings:{
        "contentlength":50000
    }
}

export default c